module.exports = __webpack_public_path__ + "static/media/NYLON.02d9251b.png";